import script from "./Instalar.vue?vue&type=script&setup=true&lang=js"
export * from "./Instalar.vue?vue&type=script&setup=true&lang=js"

import "./Instalar.vue?vue&type=style&index=0&id=de444ec2&lang=css"

const __exports__ = script;

export default __exports__